/*
  This script is used for tracking 'Added to Cart' events and managing product info displays.
*/

document.addEventListener('DOMContentLoaded', function () {

    // Initialize _learnq array if it doesn't already exist
    var _learnq = _learnq || [];

    // Add event listeners to all elements with the class 'product-form__submit'
    document.querySelectorAll('.product-form__submit').forEach((button) => {
        button.addEventListener('click', function () {
            console.log('button clicked');
            // Track 'Added to Cart' event with the _learnq array
            _learnq.push(['track', 'Added to Cart', item]);
        });
    });

    // Manage product side info display
    let triggers = document.querySelectorAll('.info-trigger');

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            let data = this.dataset.info,
                title = this.dataset.title,
                type = this.dataset.type,
                dataHtml;

            // Determine the type of data (text or image) and create the appropriate HTML
            if (type == 'text') {
                dataHtml = `<div class="product-info-wrap">${data}</div>`;
            }

            if (type == 'img') {
                dataHtml = `<div class="product-info-wrap">
          <img src="${data}" class="w-full" />
        </div>`;
            }

            // Create a new element for the product info block
            let elem = document.createElement('div');
            elem.classList.add('product-info-block');

            // Set the inner HTML of the product info block
            let html = `<div class="product-info-inner absolute p-10 bg-white h-full right-0 top-0">
            <span class="absolute close-info-block flex justify-center items-center">
                <svg class="pointer-events-none" width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 12" stroke="white" stroke-width="1" stroke-linecap="square"/>
                <path d="M2 2L12 12" stroke="white" stroke-width="1" stroke-linecap="square"/>
                </svg>
            </span>
            <div class="product-info-title">${title}</div>
            ${dataHtml}
          </div>`;

            elem.innerHTML = html;

            // Append the product info block to the body
            document.querySelector('body').appendChild(elem);

            // Add 'active' class to the product info inner element after a short delay
            setTimeout(function () {
                document.querySelector('.product-info-inner').classList.add('active');
            });

            // Add an event listener to the document for closing the product info block
            document.addEventListener('click', function (e) {
                if (
                    e.target.classList.contains('close-info-block') ||
                    e.target.classList.contains('product-info-block')
                ) {
                    document
                        .querySelector('.product-info-inner')
                        .classList.remove('active');
                    document
                        .querySelector('.product-info-inner')
                        .addEventListener('transitionend', function () {
                            elem.remove();
                        });
                }
            });
        });
    });

    // Handle the 'Read More' button click to trigger the first info-trigger element
    const readMoreElement = document.querySelector('.read-more');
    const infoTriggerElements = document.querySelectorAll('.info-trigger');

    if (readMoreElement && infoTriggerElements.length > 0) {
        readMoreElement.addEventListener('click', function () {
            infoTriggerElements[0].click();
        });
    }
});
